<template>
	<div id="app" name="app">
		<el-container>
			<router-view name="topbar"></router-view>
			<router-view name="header"></router-view>
			<!-- 主要区域容器 -->
			<el-main>
				<keepAlive>
					<router-view v-if="$route.meta.keepAlive" />
				</keepAlive>
				<router-view v-if="!$route.meta.keepAlive" />
				<go-top></go-top>
			</el-main>

			<!-- 主要区域容器END -->
			<router-view name="footer"></router-view>
		</el-container>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import GoTop from '@/components/gotop/GoTop'
import Cookie from '@/utils/cookie'

export default {
	data() {
		return {}
	},
	components: {
		'go-top': GoTop
	},
	created() {
		//获取首页配置
		// this.getHomeConfig()
		// //在页面加载时读取sessionStorage里的状态信息
		// if (sessionStorage.getItem("store")) {
		//   this.$store.replaceState(
		//     Object.assign({},
		//       this.$store.state,
		//       JSON.parse(sessionStorage.getItem("store"))
		//     )
		//   );
		// }
		// //在页面刷新时将vuex里的信息保存到sessionStorage里
		// window.addEventListener("beforeunload", () => {
		//   sessionStorage.setItem("store", JSON.stringify(this.$store.state));
		// });
	},
	computed: {
		...mapGetters({
			condolence: 'getCondolence'
		})
	},
	mounted() {
		this.loginStaus()

		// if (this.$cookie.get('PIE_MALL_Token')) {
		// 	this.$store.dispatch("user/getUserINFO", {})
		// 	this.$store.dispatch("shoppingCart/getCartINFO", {})
		// }
	},

	watch: {
		condolence(newValue, oldValue) {
			document.documentElement.style.filter = newValue.linkUrl === 'true' ? 'grayscale(100%)' : ''
		}
	},
	methods: {
		loginStaus() {
			if (this.$cookie.get('PIE_MALL_Token')) {
				this.$store.dispatch('user/getUserINFO', {})
				this.$store.dispatch('shoppingCart/getCartINFO', {})
			} else {
				this.$http
					.get(this.$const.common.getAuthorizeCode, '', true)
					.then((res) => {
						if (res.code == '200') {
							// location.href='https://www.cpeos.org.cn/personal/login?url='+window.location.href+'?tags=login';
							this.$http
								.form(this.$const.common.cpeosLogin, { authorizeCode: res.data.authorizeCode })
								.then((res) => {
									Cookie.set('PIE_MALL_Token', res.data.accessToken)
									Cookie.set('CPEOS_Token', res.data.cpeosToken)
									this.$store.dispatch('user/getUserINFO', {})
									this.$store.dispatch('shoppingCart/getCartINFO', {})
								})
								.catch((error) => {
									console.log(error, 'error')
								})
						}
					})
					.catch((error) => {
						console.log(error, 'error')
					})
			}
		},
		//获取首页配置
		async getHomeConfig() {
			try {
				let res = await this.$http.post(this.$const.common.HomePageConfiguration)
				if (res.code === 200) {
					this.$store.dispatch('getConfig', res.data)
					document.title = res.data.find((item) => item.code === 'PTMC').title
				}
			} catch (e) {
				console.log(e)
			}
		}
	}
}
</script>

<style lang="scss">
@import 'assets/css/index.css';
@import 'assets/css/public.scss';
@import 'assets/font/index.css';

.el-container {
	display: block !important;
}
/* 穿透v-html内部DOM，覆盖quill自带字号class */
.ql-size-huge {
	font-size: 32px;
}
.ql-size-large {
	font-size: 18px;
}
.ql-size-small {
	font-size: 14px;
}
.ql-size-normal {
	font-size: 14px !important;
}
/* 可选：统一行高、对齐，还原正常排版 */
.html-box :deep(p) {
	text-align: inherit;
}
.ql-align-center {
	text-align: center;
}
</style>